<template>
  <section class="section-landing-slider">
    <div>
      <slick ref="bannerSlick" :options="landingSlider">
        <div v-for="(banner, bannerKey) in banners" :key="bannerKey">
          <div>
            <!-- {{ banner }} -->
            <div class="landing-slide">
              <img
                class="img-fluid landing-slider-image d-none d-md-block"
                :src="
                  banner.is_static !== 'Y'
                    ? IMAGE_URL + banner.image_path_2
                    : IMAGE_URL + banner.image_path
                "
                @error="
                  (e) => {
                    e.target.src = '/static/img/miraj-banner-logo.jpg';
                  }
                "
              />
              <!---Only for mobile banners-->
              <img
                class="img-fluid landing-slider-image d-md-none"
                :src="
                  banner.is_static !== 'Y'
                    ?  IMAGE_URL + banner.mobile_image_path
                    : IMAGE_URL + banner.mobile_image_path
                "
                 @error="
                  (e) => {
                    e.target.src = '/static/img/miraj-banner-logo.jpg';
                  }
                "
              />

              <!--:-->
              <div
                class="landing-slide-content"
              >
                <!-- <div class="landing-slide-title">
                  {{ banner.Film_strTitle || "" }}
                </div> -->

                <!-- <ul class="dot-list">
                  <li>{{ banner.language_name || "" }}</li>
                  <li>{{ banner.genre_name || "" }}</li>
                  <li>{{ banner.Film_strCensor || "" }}</li>
                  <li>{{ banner.Film_intDuration || "" }} Minutes</li>
                  <li v-if="banner.Film_strDescriptionLong">
                    {{ banner.Film_strDescriptionLong || "" }}
                  </li>
                </ul> -->
                <div class="mt-3 d-flex banner_btn">
                  <router-link
                    v-if="banner.Film_strCode && banner.is_static === 'N'"
                    to
                    @click.native="
                      () =>
                        $router.push({
                          name: 'Movie Details',
                          params: { movie_code: banner.Film_strCode },
                        })
                    "
                    class="btn btn-primary"
                    >BOOK TICKETS</router-link
                  >
                  <div class="d-none d-md-block ml-3">
                    <a
                    v-if="banner.banner_url || banner.youtube_url"
                    to
                    data-fancybox
                    :href="banner.is_static==='Y'?banner.banner_url:banner.youtube_url"
                    class="btn btn-primary"
                    >PLAY TRAILER</a
                  >
                  </div>
                
                </div>
              </div>
            </div>
          </div>
        </div>
      </slick>
    </div>
  </section>
</template>

<script>
import MasterService from "@/apiServices/MasterService";
import { IMAGEURL } from "@/config";
export default {
  data() {
    return {
      IMAGE_URL: IMAGEURL,
      isLoadingBanners: false,
      landingSlider: {
        dots: false,
        arrows: true,
        centerMode: true,
        infinite: true,
        centerPadding: "0%",
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,

        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
            },
          },
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              centerPadding: "0%",
            },
          },
        ],
      },
      banners: [],
    };
  },
  beforeMount() {
    this.getBanners();
  },
  methods: {
    // bannerClicked(banner) {
    //   if (banner.is_static === "Y" && banner.banner_url != null) {
    //     window.location.replace(banner.banner_url);
    //   }
    // },
    async getBanners(params = {}) {
      try {
        this.isLoadingBanners = true;
        this.banners = [];
        const response = await MasterService.GetBanners(params);
        const { data } = response;
        if (data && data.status) {
          this.banners = data.data;
          console.log(this.banners)
          this.$refs.bannerSlick.destroy();
          this.$nextTick(() => {
            this.$refs.bannerSlick.create();
            this.$refs.bannerSlick.goTo(0, true);
          });
        }
      } catch (error) {
        // PLEASE SHOW POP UP HERE IF GOT FAILED
      } finally {
        setTimeout(() => (this.isLoadingBanners = false), 500);
      }
    },
  },
};
</script>
<style>
.landing-slider-image {
  /* width: 1120px;
  height: 400px; */
}





@media (max-width: 768px) {
  .banner_btn .btn-primary{
  font-size: 12px !important;
}
}

</style>



// WEBPACK FOOTER //
// src/components/partials/landingSlider.vue